<app-server-grid *ngIf="attestationPursuitGridRequest" [configuration]="attestationPursuitGridConfiguration"
                 [(request)]="attestationPursuitGridRequest"
                 [refresh]="refreshGrid"
                 [(selection)]="attestationPursuitGridSelection"
                 (selectionChange)="onAttestationPursuitGridSelectionChange($event)"
                 [actions]="actions"
                 (dataLoaded)="gridDataLoaded($event)"
                 [actionTemplate]="approvalCenterActionTemplate"
                 [filterTemplate]="filterForm"
                 [refreshViews]="refreshViews">

  <ng-template #approvalCenterActionTemplate
               let-rowData let-localActionPopover="actionPopover">
    <div class="action-template-container">
      <app-button *ngFor="let action of actions; trackBy: trackByIndex"
                  [text]="action.name"
                  (onClick)="action.action(rowData); localActionPopover.hide();"></app-button>
    </div>
  </ng-template>

    <ng-template #filterForm let-form>
      <app-tab-menu orientation="left">
        <app-tab-panel header="AID">
          <div class="ui-g-12 ui-md-12 ui-lg-12">
            <form-factory [formGroup]="form" [model]="AIDInput"></form-factory>
          </div>
        </app-tab-panel>
        <app-tab-panel header="Chase">
          <div class="ui-g-12 ui-md-12 ui-lg-12">
            <form-factory [formGroup]="form" [model]="chaseIdInput"></form-factory>
          </div>
        </app-tab-panel>
       
         <app-tab-panel header="Member">
          <div class="ui-g-12 ui-md-12 ui-lg-12">
            <form-factory [formGroup]="form" [model]="memberFirstNameInput"></form-factory>
            <form-factory [formGroup]="form" [model]="memberLastNameInput"></form-factory>
          </div>
        </app-tab-panel>
      </app-tab-menu>
    </ng-template> 
</app-server-grid>

<ng-template #childChaseIdColumn let-rowData>
  <app-chase-grid-chase-id [isOverreadFeedbackEmpty]="true" [isCurrentUserAbstractorForOverreadFeedback]="false"
    [data]="remapChildChase(rowData)" chaseIdUrl="/members/chase/:chaseId"></app-chase-grid-chase-id>
</ng-template>

<ng-template #chaseIdColumn let-rowData>
  <app-chase-grid-chase-id [isOverreadFeedbackEmpty]="true" [isCurrentUserAbstractorForOverreadFeedback]="false" [data]="rowData"
    chaseIdUrl="/members/chase/:chaseId"></app-chase-grid-chase-id>
</ng-template>

  <ng-template #commentsColumn let-rowData>
    <app-grid-forms [chaseId]="rowData.childChaseID"
                    [masterDocumentSourceId]="rowData.masterDocumentSourceID" 
                    [isFormsPresent]="rowData.forms?.length > 0"
                    (uploadFormClicked)="uploadAction(rowData)"
                    (lastFormDeleted)="reloadGrid()">
    </app-grid-forms>
  </ng-template>


<app-confirmation-modal
  class="confirmation"
  [(visible)]="isReleaseConfirmationModalVisible"
  header="Warning"
  (onYes)="releaseForRetrievalAction()"
  (onCancel)="cancelConfirmation($event)"
  acceptText="Continue"
  rejectText="Cancel">
  Are you sure you want to release this attestation without uploading attestation forms?
</app-confirmation-modal>

<p-fileUpload
  #fileUploader
  mode="basic"
  [auto]="true"
  name="file[]"
  multiple="true"
  (onSelect)="onFileSelect($event)"
  customUpload="true"
  accept=".pdf"
  (uploadHandler)="uploadDocument($event, fileUploader)"
  [style.display]="'none'">
</p-fileUpload>
